import React from "react";
import { Field } from "redux-form";
import Input from "../../../../components/common/input/Input";
import Select2 from "../../../../components/common/select/Select2";
import {
  required,
  alphaNumericSpace,
  email,
  dropdown
} from "../../../../utils/forms/validators";

export const alphaNumericSpaceValidation = msg => alphaNumericSpace(msg);
export const emailValidation = msg => email(msg);
export const dropdownValidation = msg => dropdown(msg);

export const name = alphaNumericSpaceValidation("Please enter a valid name.");
export const emailVal = emailValidation("Please enter a valid email address.");
export const relationship = dropdownValidation(
  "Please select an relationship."
);
import styles from "./References.scss";

const ReferenceForm = ({ fields, workRelations }) =>
  fields.map((reference, index) => (
    <div key={index}>
      <div className={styles.sectionTitle}>{`Endorsement #${index + 1}`}</div>
      <Field
        name={`${reference}.name`}
        type="text"
        placeholder="Name"
        component={Input}
        validate={[required, name]}
      />
      {/* <Input type="text" placeholder="Name" name='name'
          value={this.state.name}
          onChange={(event) => this.handleUserInput(event)}
          isValid={this.state.nameValid}
          error={this.state.formErrors.name}
        /> */}
      <Field
        name={`${reference}.email`}
        type="text"
        placeholder="Email"
        component={Input}
        validate={[required, emailVal]}
      />
      {/* <Input type="email" placeholder="Email" name='email'
          value={this.state.email}
          onChange={(event) => this.handleUserInput(event)}
          isValid={this.state.emailValid}
          error={this.state.formErrors.email}
        /> */}
      <Field
        name={`${reference}.relationship_id`}
        type="select"
        placeholder="Relationship"
        component={Select2}
        options={workRelations}
        validate={[required, relationship]}
      />
      {/* <Select
          placeholder='Relationship'
          name='relationship'
          options={this.props.workRelations}
          onChange={(event) => this.handleUserInput(event)}
          selected={this.state.relationship}
        /> */}
    </div>
  ));

export default ReferenceForm;



// WEBPACK FOOTER //
// ./src/routes/candidate/references/components/ReferenceForm.js